import React, { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

export const MainLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  // Handle screen resize for responsive design
  useEffect(() => {
    const checkScreenWidth = () => {
      const mobile = window.innerWidth < 768
      if (mobile) {
        setSidebarOpen(false)
      } else {
        setSidebarOpen(true)
      }
    }

    // Check on initial load
    checkScreenWidth()

    // Add resize listener
    window.addEventListener('resize', checkScreenWidth)

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenWidth)
  }, [])

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed)
    // If sidebar is closed and user toggles collapse, open it
    if (!sidebarOpen) {
      setSidebarOpen(true)
    }
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Fixed Header */}
      <Header toggleSidebar={toggleSidebar} />

      {/* Content area with padding for fixed header */}
      <div className="flex flex-1 pt-14">
        {/* Fixed Sidebar */}
        <div
          className={`transform transition-transform duration-200 ease-in-out fixed top-14 bottom-0 left-0 ${
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } md:translate-x-0 z-40`}
          style={{ height: 'calc(100vh - 3.5rem)' }}
        >
          <Sidebar
            collapsed={sidebarCollapsed}
            onToggleCollapse={toggleSidebarCollapse}
          />
        </div>

        {/* Main content with margin for sidebar */}
        <main
          className={`flex-1 transition-all duration-300 ${
            sidebarOpen ? (sidebarCollapsed ? 'md:ml-16' : 'md:ml-64') : 'ml-0'
          }`}
        >
          <div className="container mx-auto p-6">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Backdrop for mobile - only shown when sidebar is open on mobile */}
      {sidebarOpen && window.innerWidth < 768 && (
        <div
          className="fixed inset-0 bg-black/50 dark:bg-black/70 z-30 md:hidden"
          onClick={toggleSidebar}
        />
      )}
    </div>
  )
}